<template>
  <div class="crop-element">
    <x-table
      :columns="table.columns"
      :data="table.data"
      :loading="table.loading"
      :config="config"
      @add="add"
      @search="search"
      @page-change="pageChange"
      @page-size-change="pageSizeChange"
    ></x-table>

    <Modal
      v-model="modal.show"
      :title="modal.title"
      @on-visible-change="modalShow"
    >
      <Form ref="form" :model="form" :rules="rules" :label-width="110">
        <FormItem label="产品" prop="productId">
          <Select v-model="form.productId">
            <Option v-for="item in category" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </FormItem>
        <FormItem label="元素" prop="elementId">
          <Select v-model="form.elementId">
            <Option v-for="item in element" :value="item.id" :key="item.id">{{
              item.elementName
            }}</Option>
          </Select>
        </FormItem>
        <FormItem label="所需营养元素" prop="elementValue">
          <Input v-model="form.elementValue">
            <span slot="append">kg</span>
          </Input>
        </FormItem>
        <FormItem label="产量水平" prop="output">
          <Input v-model="form.output">
            <span slot="append">t/hm2</span>
          </Input>
        </FormItem>
      </Form>
      <p slot="footer" style="text-align: center">
        <Button type="primary" :loading="modal.submitLoading" @click="submit"
          >提交</Button
        >
        <Button @click="() => (modal.show = false)">取消</Button>
      </p>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      table: {
        columns: [
          {
            title: "产品名称",
            minWidth: 100,
            key: "productName",
          },
          {
            title: "元素名称",
            minWidth: 100,
            key: "elementName",
          },
          {
            title: "所需元素(kg)",
            minWidth: 120,
            key: "elementValue",
          },
          {
            title: "产量水平(t/hm2)",
            minWidth: 140,
            key: "output",
          },
          {
            title: '操作',
            width: 100,
            render: (h, { row }) => {
              return (
                <div>
                  <a onClick={() => this.edit(row)}>编辑</a>
                </div>
              )
            }
          }
        ],
        data: [],
        loading: false,
      },
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      search_data: {},

      modal: {
        show: false,
        title: "",
        submitLoading: false,
      },
      form: {
        id: "",
        productId: "",
        elementId: "",
        elementValue: "",
        output: "",
      },
      rules: {
        productId: [{ required: true, message: "请选择产品" }],
        elementId: [{ required: true, message: "请选择元素" }],
        elementValue: [{ required: true, message: "请填写所需营养元素" }],
        output: [{ required: true, message: "请填写产量水平" }],
      },
      category: [],
      element: [],
    };
  },
  computed: {
    config() {
      let config = {
        filter: {
          add: {
            addBtnName: "新增作物元素",
          },
          width: 200,
          filterBox: [
            {
              conditionName: "产品",
              component: "select",
              field: "productId",
              data: this.category,
              defaultValue: "",
              parameterField: "id",
              showField: "name",
            },
            {
              conditionName: "元素",
              component: "select",
              field: "elementId",
              data: this.element,
              defaultValue: "",
              parameterField: "id",
              showField: "elementName",
            },
          ],
        },
        page: this.page,
      };
      return config;
    },
  },
  methods: {
    add() {
      this.modal = {
        show: true,
        title: "新增作物元素",
        submitLoading: false,
      };
    },

    search(data) {
      this.page.pageNo = 1;
      this.search_data = data;
      this.getList();
    },

    pageChange(pageNo) {
      this.page.pageNo = pageNo;
      this.getList();
    },
    pageSizeChange(pageSize) {
      this.page.pageSize = pageSize
      this.getList()
    },

    getList() {
      this.table.loading = true;
      this.$post(this.$api.CROP_ELEMENT.LIST, {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        ...this.search_data,
      })
        .then((res) => {
          this.table.data = res.list;
          this.page.total = +res.total;
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    getCategory() {
      this.$post(this.$api.PRODUCT_INFO.LIST, {
        type: "1",
      }).then((res) => {
        this.category = res.list;
      });
    },
    getElement() {
      this.$post(this.$api.ELEMENT.LIST, {
        pageNo: 1,
        pageSize: 999,
      }).then((res) => {
        this.element = res.list;
      });
    },
    edit(row) {
      for (let key in this.form) {
        this.form[key] = row[key]
      }
      this.modal = {
        show: true,
        title: '编辑作物元素',
        submitLoading: false
      }
    },
    modalShow(visible) {
      if (visible) return;
      this.form = {
        id: "",
        productId: "",
        elementId: "",
        elementValue: "",
        output: "",
      };
      this.$refs.form.resetFields();
    },
    submit() {
      this.$refs.form.validate().then((res) => {
        if (!res) return;
        this.modal.submitLoading = true;
        this.$post(this.$api.CROP_ELEMENT.ADD, {
          ...this.form,
        })
          .then(() => {
            this.getList();
            this.modal.show = false;
          })
          .finally(() => {
            this.modal.submitLoading = false;
          });
      });
    },
  },
  mounted() {
    this.getList();
    this.getCategory();
    this.getElement();
  },
};
</script>

<style lang="less" scoped>
.crop-element {
  width: 100%;
  height: 100%;
}
</style>